module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10018.3a10a3a3.jpg";